import React, { useState } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './InlineEdit.module.scss';
import SimpleInput from '../SimpleInput';
import { arrayMove } from '../../../utils/array';
import { alertError } from '../../../store/actions/alert';
import { useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';

export default function InlineEdit(props) {
  const { hidden, cancel, shouldDisplayEditIconOnRight, isValueRequiredForSubmit } = props;

  const [value, setValue] = useState(props.value);
  const [editing, setEditing] = useState(false);
  const dispatch = useDispatch();

  const isEmptyValue = !value || value === '';

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      saveOrEdit();
    } else if (e.key === 'Escape') {
      reset();
    }
  };

  const reset = (e) => {
    setValue(props.value);
    setEditing(false);
  };

  const saveOrEdit = (e) => {
    if (isValueRequiredForSubmit && isEmpty(value)) {
      dispatch(alertError('A value is required'));
      return;
    }

    if (editing) {
      props.onChange(value);
    } else if (hidden) {
      setValue('');
    }

    setEditing(!editing);
  };

  const renderInput = () => {
    return <SimpleInput value={isEmptyValue ? '' : value} onChange={handleChange} onKeyDown={handleKeyDown} />;
  };

  const renderValue = () => {
    let displayValue;
    let className;

    if (hidden) {
      displayValue = '*'.repeat(20);
      className = styles.input;
    } else {
      displayValue = isEmptyValue ? props.emptyValue : value;
      className = cn(styles.input, isEmptyValue ? styles.empty : '');
    }

    return (
      <button onClick={() => setEditing(true)} className={className}>
        {displayValue}
      </button>
    );
  };

  function getElementsToRender() {
    const elements = [
      <span onClick={saveOrEdit} className={cn(styles.icon, editing ? 'ic-save' : 'ic-edit')} />,
      <>{editing ? renderInput() : renderValue()}</>,
      <>{editing && cancel && <span onClick={reset} className={cn(styles.icon, 'ic-close')} />}</>,
    ];

    if (shouldDisplayEditIconOnRight) {
      return arrayMove(elements, 0, 2);
    }

    return elements;
  }

  const elementsToRender = getElementsToRender();

  return (
    <div className={cn(styles.inlineEdit)}>
      {elementsToRender.map((e, idx) => React.cloneElement(e, { key: `element-${idx}` }))}
    </div>
  );
}

InlineEdit.defaultProps = {
  value: '',
  emptyValue: 'Add value',
};

InlineEdit.propTypes = {
  value: PropTypes.string,
  hidden: PropTypes.bool,
  cancel: PropTypes.bool,
  emptyValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  shouldDisplayEditIconOnRight: PropTypes.bool,
};
